import { VermoegenComponent } from './vermoegen/vermoegen.component';
import { BilanzComponent } from './bilanz/bilanz.component';
import { BuchungComponent } from './buchungen/buchung/buchung.component';
import { BuchungenComponent } from './buchungen/buchungen.component';
import { KontosComponent } from './kontos/kontos.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { KontoComponent } from './kontos/konto/konto.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'buchungen',
    pathMatch: 'full'
  },
  {
    path: 'bilanz',
    component: BilanzComponent
  },
  {
    path: 'vermoegen',
    component: VermoegenComponent
  },
  {
    path: 'kontos',
    component: KontosComponent
  },
  {
    path: 'kontos/:konto',
    component: KontoComponent
  },
  {
    path: 'buchungen',
    component: BuchungenComponent 
  },
  {
    path: 'buchungen/:jahr/:monat',
    component: BuchungenComponent 
  },
  {
    path: 'buchungen/:buchung',
    component: BuchungComponent 
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
